import React , {useReducer, useCallback} from 'react'
import reducer, {setState} from '../../../utils/CommonReducer'
import AnPopup from "../../../cta_utils/AnPopup"
import {AnInputBox} from "../../../input_utils/AnInput"
import {Button} from "../../../cta_utils/AnButton"
import {apiAgent} from "../../../../axiosConfig"
const FlaggedReplies = ({article, ...props}) => {
    const [componentState, setComponentState] = useReducer(reducer, {
        popupsList: {},
        comment: "",
        isLoading: {},
        errors: {}    
    })    
    const {popupsList, comment, isLoading} = componentState
    
    const alreadyReplied = () => {
        return (
            <div className="green_keyword_pill text_link_extra_small" style={{padding: "2px 12px", borderRadius: "40px"}}>
                Replied
            </div>
        )
    }

    const submitReply = () => {
        let errors = {}
        if(!comment) errors["comment"] = "Please enter some text";
        if(Object.keys(errors).length > 0){
            setState(setComponentState)({errors})
            return;
        }
        setState(setComponentState)({errors, isLoading: {sendingReply: true}})
        
        apiAgent({
            method: "post",
            url: `/flagged_articles/${article.id}/reply`,
            data: {
                reply: comment
            },
        }).then(
            (response) => {
                setState(setComponentState)({isLoading: {}, popupsList: {}})
                props.replyCallback({article: {...article, reply: comment}, successMsg: "Reply sent"})
            },
            (error) => {
                setState(setComponentState)({isLoading: {}, popupsList: {}})
            }
        );
    }
    if(article.reply) return alreadyReplied()
    const renderReplyToPopup = () => {
        return(
            <AnPopup name="replyToUserPopup" handleOnClosePopup={() => {setState(setComponentState)({popupsList: {...popupsList, replyToUserPopup: false}})}}>
                <div className="text_subtitle_big" style={{marginBottom: "10px"}}>Reply to the user</div>
                <AnInputBox>            
                    <textarea name="comment" value={comment} onChange={(e) => setState(setComponentState)({[e.target.name]: e.target.value})} placeholder="Reply"></textarea>
                </AnInputBox>
                <div className="default_flex_container" style={{gap: "12px", marginTop: "16px"}}>
                    <Button type='Primary' innerButtonStye={{padding: "8px 13px"}} onClick={submitReply} isLoading={isLoading.sendingReply}>Send Reply</Button>
                    <Button type="Secondary" innerButtonStye={{padding: "8px 13px"}} onClick={() => setState(setComponentState)({popupsList: {}})}>Cancel</Button>
                </div>
            </AnPopup>
        )
    }
    return (
        <>
            <div className="text_subtitle" style={{cursor: "pointer"}} onClick={() => {
                setState(setComponentState)({popupsList:{replyToUserPopup: true}})
            }}>
                Reply to the user
            </div>
            {popupsList.replyToUserPopup && renderReplyToPopup()}
        </>
    )
}

export default FlaggedReplies